import { useQuery } from '@tanstack/react-query';

import { INBOX_API_KEY } from '@/src/components/project/Inbox2/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { DOCUMENT_BASE_URL } from '.';

import { AutomatedDraftResponse } from '../types/draft';

const url = `${DOCUMENT_BASE_URL}/automation/:automationId/getResult`;

export type GetAutomationResultResponse = {
  draft: AutomatedDraftResponse;
  status: 'processing' | 'completed' | 'cancelled' | 'failed';
};

export const automationResultQueryKey = (
  inboxDocumentId: UseGetAutomationResultOptions['inboxDocumentId'],
  automationId: number
) => [INBOX_API_KEY, 'automation', inboxDocumentId, automationId];

export const getAutomationResult = (automationId: number): Promise<GetAutomationResultResponse> => {
  return axios.get(generateRoutePath(url, { automationId }));
};
type QueryFnType = typeof getAutomationResult;

type UseGetAutomationResultOptions = {
  inboxDocumentId: number;
  automationId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAutomationResult = ({
  inboxDocumentId,
  automationId,
  config,
}: UseGetAutomationResultOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: automationResultQueryKey(inboxDocumentId, automationId),
    queryFn: () => getAutomationResult(automationId),
    staleTime: Infinity,
    ...config,
  });
};
